'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../index-6ed9f31c.js');
var colorBuilder = require('../../colorBuilder-0e3465cf.js');
require('../../extends-f8003900.js');
require('../../polished.esm-0312677e.js');

var colorVariantsShape = index.PropTypes.oneOf(colorBuilder.colorVariants);

exports.default = colorVariantsShape;
//# sourceMappingURL=colorVariantsShape.js.map
